export const translations = {
  it: {
    nav_cammino: "Il Cammino",
    nav_tappe: "Tappe",
    nav_territorio: "Territorio",
    nav_prodotti: "Prodotti",
    nav_servizi: "Servizi",
    nav_progetto: "Progetto",
    nav_partner: "Diventa partner",
    nav_contatti: "Contatti",

    hero_eyebrow: "Sicilia Orientale",
    hero_title_1: "Da Catania a Ragusa",
    hero_title_2: "sui binari",
    hero_title_3: "attraverso nove perle della Sicilia Orientale",
    hero_subtitle: "Un cammino ciclo-pedonale di 285 km tra le ex ferrovie, le trazzere storiche e i siti UNESCO. Cinque secoli di storia in una sola linea.",
    hero_cta_walk: "A piedi",
    hero_cta_bike: "In bici",

    stat_km: "chilometri di cammino",
    stat_tappe: "tappe principali",
    stat_unesco: "siti UNESCO attraversati",
    stat_ferrovia: "ex ferrovia storica",

    ferrovia_eyebrow: "1868 → 1956 → oggi",
    ferrovia_title: "Ferrovia dimenticata, cammino ritrovato",
    ferrovia_body: "Nel 1956 l'ultimo treno percorse la linea Siracusa–Ragusa–Vizzini. Da allora, settant'anni di silenzio hanno restituito i binari alla natura. Il cammino ne raccoglie la memoria unendo il sedime ferroviario ancora percorribile (Pantalica, Rossana Maiorca) alle trazzere storiche dell'Antica Trasversale Sicula e alle strade secondarie a basso traffico.",
    ferrovia_stations_label: "Nove siti UNESCO. Due ex-ferrovie. Un solo paesaggio ibleo.",

    modes_eyebrow: "Due modi di camminare",
    modes_title: "Scegli il tuo ritmo",
    walk_title: "A piedi",
    walk_desc: "Un cammino lento, tappe corte spezzabili, ombra dei carrubi.",
    walk_time: "Tempo medio",
    walk_time_val: "12-16 giorni",
    bike_title: "In bici",
    bike_desc: "Gravel 40+ mm o MTB. Luci obbligatorie in galleria.",
    bike_time: "Tempo medio",
    bike_time_val: "5-7 giorni",

    stato_eyebrow: "Onestà operativa",
    stato_title: "Stato del cammino",
    stato_intro: "Il tracciato è in fase pilota. Verifiche di campo aggiornate al 22/09/2026. Alcuni tratti sono pienamente transitabili, altri richiedono attenzione o autorizzazione.",
    status_open: "Transitabile",
    status_warn: "Con cautela",
    status_closed: "Condizionato",

    section_catania_siracusa: "Catania → Siracusa",
    section_siracusa_ragusa: "Siracusa → Ragusa",
    section_extra: "Percorsi pedonali",

    partner_eyebrow: "Costruiamo insieme",
    partner_title: "Diventa partner del Cammino",
    partner_body: "Cerchiamo comuni, alloggi, GAL, guide, noleggi bici, ristoratori. Un progetto pubblico si fa con chi lo abita.",
    partner_cta: "Scopri come",

    footer_tagline: "Un cammino che attraversa i siti UNESCO della Sicilia Orientale.",
    footer_legal_note: "Il tracciato attraversa geograficamente aree iscritte alla World Heritage List UNESCO. Nessun endorsement istituzionale è implicito.",
    footer_rights: "Tutti i diritti riservati",

    cammino_title: "Il Cammino",
    cammino_subtitle: "Panoramica, mappa interattiva, stato, preparazione",
    cammino_pano_title: "Panoramica del tracciato",
    cammino_map_title: "Mappa interattiva",
    cammino_map_intro: "Il tracciato collega Catania a Ragusa Ibla attraverso nove siti UNESCO, due ex-ferrovie e le trazzere storiche degli Iblei.",
    cammino_prep_title: "Come prepararsi",
    prep_walk: "Preparazione a piedi",
    prep_walk_body: "Zaino massimo 8 kg, calzature da trekking leggero, cappello e crema solare. Riserva d'acqua di almeno 1,5 L. Alcune tappe (Militello-Caltagirone, Ferla-Sortino) sono tecniche: prevedere spezzata su due giorni.",
    prep_bike: "Preparazione in bici",
    prep_bike_body: "Gravel o MTB front, copertoni tassellati minimo 40 mm. Casco obbligatorio, luci frontali obbligatorie per le gallerie di Pantalica. Verificare stato SP il giorno di partenza.",

    tappa_km: "Chilometri",
    tappa_elevation: "Dislivello",
    tappa_walk: "A piedi",
    tappa_bike: "In bici",
    tappa_ebike: "In e-bike",
    tappa_difficulty: "Difficoltà",
    tappa_start: "Partenza",
    tappa_end: "Arrivo",
    tappa_surface: "Fondo",
    tappa_traffic: "Traffico",
    tappa_highlights: "Punti salienti",
    tappa_notes: "Note operative",
    tappa_unesco: "Siti UNESCO su questa tappa",
    tappa_next: "Tappa successiva",
    tappa_prev: "Tappa precedente",
    tappa_map: "Mappa della tappa",
    tappa_type_walk: "Solo pedonale",
    tappa_type_both: "Ciclo-pedonale",

    territorio_title: "Territorio",
    territorio_subtitle: "Nove siti UNESCO, un solo paesaggio",
    territorio_inscribed: "Iscrizione UNESCO",
    territorio_history: "Storia",
    territorio_places: "Luoghi da visitare",
    territorio_back: "Torna a Territorio",

    prodotti_title: "Prodotti del Territorio",
    prodotti_subtitle: "Diciotto eccellenze della cucina iblea, tra tradizione e biodiversità",
    prodotti_disclaimer: "Contenuti indicativi da revisionare con esperto gastronomico locale.",
    prodotti_areas: "Aree di produzione",
    prodotti_tagline: "Descrizione",
    prodotti_salute: "Benefici per la salute",
    prodotti_usi: "Usi in cucina",
    prodotti_ricette: "Ricette tipiche",
    prodotti_season: "Stagionalità",
    prodotti_in_season: "In stagione ora",
    seasonal_eyebrow: "Sapori del mese",
    seasonal_title: "In stagione lungo il cammino",
    seasonal_intro: "Ogni mese la Sicilia Orientale offre un calendario diverso di frutti, ortaggi e mieli. Ecco cosa trovi nei mercati e nelle sagre proprio adesso.",
    seasonal_cta: "Scopri tutti i prodotti",
    sagre_eyebrow: "Sagre e feste",
    sagre_title: "In festa lungo il cammino",
    sagre_intro: "Deviazioni golose e culturali: le sagre e le feste popolari attive proprio in questo mese nella Sicilia Orientale e sui Monti Iblei.",
    sagre_no_events: "Questo mese nessuna sagra maggiore. Buon momento per un cammino più raccolto.",
    sagre_when: "Quando",
    sagre_where: "Dove",
    sagre_linked_product: "Prodotto tipico",
    month_1: "gennaio", month_2: "febbraio", month_3: "marzo", month_4: "aprile",
    month_5: "maggio", month_6: "giugno", month_7: "luglio", month_8: "agosto",
    month_9: "settembre", month_10: "ottobre", month_11: "novembre", month_12: "dicembre",
    cat_agrumi: "Agrumi",
    cat_ortaggi: "Ortaggi",
    cat_legumi: "Legumi",
    cat_pane: "Pane e farine",
    cat_condimenti: "Condimenti",
    cat_dolci: "Dolci",
    cat_miele: "Mieli",
    cat_latticini: "Latticini",
    cat_frutta_secca: "Frutta e frutta secca",
    cat_erbe: "Erbe aromatiche",
    cat_all: "Tutte le categorie",

    servizi_title: "Servizi lungo il cammino",
    servizi_subtitle: "Dormire, mangiare, muoversi",
    servizi_sleep: "Dormire",
    servizi_sleep_desc: "B&B, agriturismi e ostelli lungo il tracciato. Directory in costruzione.",
    servizi_eat: "Mangiare",
    servizi_eat_desc: "Cucina iblea: pane cunzato, ravioli di ricotta, cioccolato di Modica.",
    servizi_bike: "Noleggio bici",
    servizi_bike_desc: "Punti di noleggio gravel e MTB a Catania, Siracusa, Noto e Ragusa.",
    servizi_guide: "Guide",
    servizi_guide_desc: "Guide escursionistiche e cicloturistiche autorizzate.",
    servizi_bags: "Trasporto bagagli",
    servizi_bags_desc: "Servizio di trasporto zaini tra le tappe. In fase di attivazione.",

    progetto_title: "Il Progetto",
    progetto_subtitle: "Un progetto condiviso per uno sviluppo ecosostenibile dei Monti Iblei",
    progetto_vision: "Visione e obiettivi",
    progetto_vision_body: "Il Cammino Ibleo UNESCO nasce per unire sotto un unico marchio identitario le energie, le competenze e le risorse dei Monti Iblei — un sistema territoriale che si estende tra le province di Siracusa, Ragusa e parte della Città Metropolitana di Catania. L'iniziativa trasforma il tracciato dell'ex ferrovia Siracusa–Ragusa in un grande corridoio di mobilità dolce che connette i siti UNESCO del Val di Noto (Palazzolo Acreide, Noto, Modica, Scicli, Ragusa Ibla) con la Necropoli di Pantalica, il teatro greco di Akrai, Castelluccio, Eloro, Kamarina, Vizzini e la Cava d'Ispica. L'obiettivo è mettere in rete paesaggio, cultura, archeologia, ambiente, produzioni locali e comunità, promuovendo un nuovo modello di sviluppo basato sul turismo lento, sulla rigenerazione delle infrastrutture dismesse e sul rafforzamento dell'identità delle comunità locali.",
    progetto_align: "Partner istituzionali e quadro di riferimento",
    progetto_align_body: "Cerchiamo l'adesione dei Comuni UNESCO della Sicilia Orientale, delle Soprintendenze, dei GAL, degli enti del Terzo Settore, delle università e delle imprese del territorio per co-progettare un'infrastruttura condivisa. La prima fase pilota è dedicata al sistema territoriale della Necropoli di Pantalica, con il coinvolgimento diretto dei Comuni di Ferla, Cassaro e Sortino. Il progetto è pienamente coerente con il Piano Generale della Mobilità Ciclistica Urbana ed Extraurbana 2022–2024 (DM 23/8/2022), con la L.R. 2/2018, con la Strategia Nazionale per le Aree Interne (SNAI) e con gli Obiettivi 11, 13 e 15 dell'Agenda ONU 2030.",
    progetto_objectives_title: "Obiettivi strategici",
    progetto_objectives: [
      "Promuovere il cicloturismo come motore di sviluppo economico e sociale del territorio ibleo, anche attraverso servizi di bike sharing a pedalata assistita",
      "Diffondere una nuova cultura della mobilità sostenibile — la bicicletta come mezzo di mobilità quotidiana e non solo per il tempo libero",
      "Recuperare le ex stazioni ferroviarie come punti di accoglienza, assistenza e ristoro per cicloturisti e camminatori",
      "Integrare mobilità ciclistica, automobilistica e trasporto pubblico, collegando centri abitati, siti culturali e aree naturalistiche",
      "Favorire la permanenza delle comunità locali e sostenere le economie di prossimità delle aree interne",
    ],
    progetto_marchio_title: "Il marchio Cammino Ibleo UNESCO",
    progetto_marchio_body: "Il marchio rappresenta il senso di appartenenza a una comunità che riconosce nel proprio territorio un patrimonio comune da custodire, valorizzare e trasmettere alle future generazioni. Non è soltanto un elemento distintivo, ma il simbolo di una rete territoriale che unisce istituzioni, operatori, cittadini e visitatori nel rispetto dell'ambiente, nella tutela del paesaggio e nella valorizzazione del patrimonio storico, culturale e archeologico.",
    progetto_dossier_title: "Scarica il Dossier istituzionale",
    progetto_dossier_body: "Scarica la presentazione completa del progetto Cammino Ibleo UNESCO: visione, obiettivi, fase pilota su Pantalica e quadro di riferimento normativo.",
    progetto_dossier_cta: "SCARICA IL DOSSIER (PDF)",

    partner_page_title: "Diventa partner",
    partner_page_subtitle: "Il Cammino esiste perché lo costruiamo insieme",
    partner_type_comune: "Comune / Ente pubblico",
    partner_type_alloggio: "Alloggio",
    partner_type_gal: "GAL / Consorzio",
    partner_type_guida: "Guida / Servizio",
    partner_type_altro: "Altro",
    partner_form_org: "Organizzazione",
    partner_form_name: "Nome referente",
    partner_form_type: "Tipologia",
    partner_form_message: "Messaggio",

    contatti_title: "Contatti",
    contatti_subtitle: "Scrivici, il cammino risponde",
    form_fullname: "Nome completo",
    form_email: "Email",
    form_subject: "Oggetto",
    form_message: "Messaggio",
    form_submit: "Invia",
    form_submit_success: "Grazie, ti risponderemo via email.",
  },
  en: {
    nav_cammino: "The Trail",
    nav_tappe: "Stages",
    nav_territorio: "Territory",
    nav_prodotti: "Products",
    nav_servizi: "Services",
    nav_progetto: "Project",
    nav_partner: "Become a partner",
    nav_contatti: "Contact",

    hero_eyebrow: "Eastern Sicily",
    hero_title_1: "From Catania to Ragusa",
    hero_title_2: "on the tracks",
    hero_title_3: "through nine jewels of Eastern Sicily",
    hero_subtitle: "A 285 km walking and cycling trail through former railways, historic trazzere and UNESCO sites. Five centuries of history on a single line.",
    hero_cta_walk: "On foot",
    hero_cta_bike: "By bike",

    stat_km: "kilometres of trail",
    stat_tappe: "main stages",
    stat_unesco: "UNESCO sites crossed",
    stat_ferrovia: "historic former railway",

    ferrovia_eyebrow: "1868 → 1956 → today",
    ferrovia_title: "Forgotten railway, rediscovered path",
    ferrovia_body: "In 1956 the last train ran the Syracuse–Ragusa–Vizzini line. Seventy years of silence have returned the tracks to nature. The trail gathers this memory joining the railway bed still passable (Pantalica, Rossana Maiorca), the historic trazzere of the Antica Trasversale Sicula and low-traffic secondary roads.",
    ferrovia_stations_label: "Nine UNESCO sites. Two former railways. One Iblean landscape.",

    modes_eyebrow: "Two ways to walk",
    modes_title: "Choose your rhythm",
    walk_title: "On foot",
    walk_desc: "A slow trail, short splittable stages, carob-tree shade.",
    walk_time: "Average time",
    walk_time_val: "12-16 days",
    bike_title: "By bike",
    bike_desc: "Gravel 40+ mm or MTB. Lights mandatory in tunnels.",
    bike_time: "Average time",
    bike_time_val: "5-7 days",

    stato_eyebrow: "Operational honesty",
    stato_title: "Trail status",
    stato_intro: "The route is in pilot phase. Field checks updated 22/09/2026. Some sections are fully passable, others require caution or authorization.",
    status_open: "Passable",
    status_warn: "With caution",
    status_closed: "Conditional",

    section_catania_siracusa: "Catania → Syracuse",
    section_siracusa_ragusa: "Syracuse → Ragusa",
    section_extra: "Walking loops",

    partner_eyebrow: "Build with us",
    partner_title: "Become a partner of the Trail",
    partner_body: "We are looking for municipalities, accommodations, GALs, guides, bike rentals, restaurateurs. A public project is made with those who inhabit it.",
    partner_cta: "Learn how",

    footer_tagline: "A trail crossing the UNESCO sites of Eastern Sicily.",
    footer_legal_note: "The route geographically crosses areas inscribed on the UNESCO World Heritage List. No institutional endorsement is implied.",
    footer_rights: "All rights reserved",

    cammino_title: "The Trail",
    cammino_subtitle: "Overview, interactive map, status, preparation",
    cammino_pano_title: "Route overview",
    cammino_map_title: "Interactive map",
    cammino_map_intro: "The trail connects Catania to Ragusa Ibla through nine UNESCO sites, two former railways and the historic Iblean trazzere.",
    cammino_prep_title: "How to prepare",
    prep_walk: "Walking preparation",
    prep_walk_body: "Backpack up to 8 kg, light trekking shoes, hat and sunscreen. Water reserve of at least 1.5 L. Some stages (Militello-Caltagirone, Ferla-Sortino) are technical: plan a two-day split.",
    prep_bike: "Cycling preparation",
    prep_bike_body: "Gravel or front-MTB, knobby tyres min 40 mm. Helmet mandatory, front lights mandatory for Pantalica tunnels. Check SP status on the day of departure.",

    tappa_km: "Kilometres",
    tappa_elevation: "Elevation gain",
    tappa_walk: "On foot",
    tappa_bike: "By bike",
    tappa_ebike: "By e-bike",
    tappa_difficulty: "Difficulty",
    tappa_start: "Start",
    tappa_end: "End",
    tappa_surface: "Surface",
    tappa_traffic: "Traffic",
    tappa_highlights: "Highlights",
    tappa_notes: "Operational notes",
    tappa_unesco: "UNESCO sites on this stage",
    tappa_next: "Next stage",
    tappa_prev: "Previous stage",
    tappa_map: "Stage map",
    tappa_type_walk: "Pedestrian only",
    tappa_type_both: "Cycle-pedestrian",

    territorio_title: "Territory",
    territorio_subtitle: "Nine UNESCO sites, one landscape",
    territorio_inscribed: "UNESCO inscription",
    territorio_history: "History",
    territorio_places: "Places to visit",
    territorio_back: "Back to Territory",

    prodotti_title: "Local Products",
    prodotti_subtitle: "Eighteen excellences of Iblean cuisine, between tradition and biodiversity",
    prodotti_disclaimer: "Indicative content to be reviewed by a local gastronomic expert.",
    prodotti_areas: "Production areas",
    prodotti_tagline: "Description",
    prodotti_salute: "Health benefits",
    prodotti_usi: "Uses in cooking",
    prodotti_ricette: "Typical recipes",
    prodotti_season: "Seasonality",
    prodotti_in_season: "In season now",
    seasonal_eyebrow: "Flavours of the month",
    seasonal_title: "In season along the trail",
    seasonal_intro: "Every month Eastern Sicily offers a different calendar of fruits, vegetables and honeys. Here's what you find in markets and festivals right now.",
    seasonal_cta: "Discover all products",
    sagre_eyebrow: "Festivals and feasts",
    sagre_title: "Celebrating along the trail",
    sagre_intro: "Tasty and cultural detours: folk festivals and feasts active this very month in Eastern Sicily and the Iblei mountains.",
    sagre_no_events: "No major festivals this month. A good time for a more contemplative walk.",
    sagre_when: "When",
    sagre_where: "Where",
    sagre_linked_product: "Typical product",
    month_1: "January", month_2: "February", month_3: "March", month_4: "April",
    month_5: "May", month_6: "June", month_7: "July", month_8: "August",
    month_9: "September", month_10: "October", month_11: "November", month_12: "December",
    cat_agrumi: "Citrus",
    cat_ortaggi: "Vegetables",
    cat_legumi: "Legumes",
    cat_pane: "Bread and flours",
    cat_condimenti: "Condiments",
    cat_dolci: "Sweets",
    cat_miele: "Honeys",
    cat_latticini: "Dairy",
    cat_frutta_secca: "Fruit and nuts",
    cat_erbe: "Aromatic herbs",
    cat_all: "All categories",

    servizi_title: "Services along the trail",
    servizi_subtitle: "Sleep, eat, move",
    servizi_sleep: "Sleep",
    servizi_sleep_desc: "B&Bs, farmhouses and hostels along the route. Directory under construction.",
    servizi_eat: "Eat",
    servizi_eat_desc: "Iblean cuisine: pane cunzato, ricotta ravioli, Modica chocolate.",
    servizi_bike: "Bike rental",
    servizi_bike_desc: "Gravel and MTB rental points in Catania, Syracuse, Noto and Ragusa.",
    servizi_guide: "Guides",
    servizi_guide_desc: "Authorized hiking and cycling guides.",
    servizi_bags: "Luggage transfer",
    servizi_bags_desc: "Backpack transfer service between stages. Activation in progress.",

    progetto_title: "The Project",
    progetto_subtitle: "A shared project for the ecosustainable development of the Iblean Mountains",
    progetto_vision: "Vision and objectives",
    progetto_vision_body: "The Cammino Ibleo UNESCO was created to unite — under a single identity brand — the energies, skills and resources of the Iblean Mountains, a territorial system spanning the provinces of Syracuse, Ragusa and part of the Metropolitan City of Catania. The initiative transforms the former Syracuse–Ragusa railway into a great gentle-mobility corridor that connects the UNESCO Val di Noto sites (Palazzolo Acreide, Noto, Modica, Scicli, Ragusa Ibla) with the Necropolis of Pantalica, the Greek theatre of Akrai, Castelluccio, Eloro, Kamarina, Vizzini and Cava d'Ispica. The goal is to network landscape, culture, archaeology, environment, local produce and communities, promoting a new development model based on slow tourism, regeneration of disused infrastructure and strengthening of local community identity.",
    progetto_align: "Institutional partners and reference framework",
    progetto_align_body: "We seek the engagement of the Eastern Sicily UNESCO Municipalities, the Superintendencies, Local Action Groups, Third-Sector organisations, universities and local businesses to co-design a shared infrastructure. The first pilot phase is dedicated to the Pantalica Necropolis territorial system, directly involving the Municipalities of Ferla, Cassaro and Sortino. The project is fully consistent with the General Urban and Extra-Urban Cycling Mobility Plan 2022–2024 (DM 23/8/2022), Regional Law 2/2018, the National Strategy for Inner Areas (SNAI) and UN Agenda 2030 Goals 11, 13 and 15.",
    progetto_objectives_title: "Strategic objectives",
    progetto_objectives: [
      "Promote cycling tourism as a driver of economic and social development, including pedal-assisted bike-sharing services",
      "Spread a new culture of sustainable mobility — the bicycle as a daily transport mode, not just for leisure",
      "Recover disused railway stations as reception, assistance and refreshment points for cyclists and hikers",
      "Integrate cycling, car and public transport, linking inhabited centres, cultural sites and natural areas",
      "Support the permanence of local communities and the proximity economies of the inner areas",
    ],
    progetto_marchio_title: "The Cammino Ibleo UNESCO brand",
    progetto_marchio_body: "The brand represents the sense of belonging to a community that recognises its territory as a common heritage to be preserved, enhanced and passed on to future generations. It is not just a distinctive mark but the symbol of a territorial network that unites institutions, operators, citizens and visitors in respect for the environment, the protection of the landscape and the valorisation of historical, cultural and archaeological heritage.",
    progetto_dossier_title: "Download the Institutional Dossier",
    progetto_dossier_body: "Download the full presentation of the Cammino Ibleo UNESCO project: vision, objectives, Pantalica pilot phase and regulatory framework.",
    progetto_dossier_cta: "DOWNLOAD THE DOSSIER (PDF)",

    partner_page_title: "Become a partner",
    partner_page_subtitle: "The Trail exists because we build it together",
    partner_type_comune: "Municipality / Public entity",
    partner_type_alloggio: "Accommodation",
    partner_type_gal: "GAL / Consortium",
    partner_type_guida: "Guide / Service",
    partner_type_altro: "Other",
    partner_form_org: "Organization",
    partner_form_name: "Contact name",
    partner_form_type: "Type",
    partner_form_message: "Message",

    contatti_title: "Contact",
    contatti_subtitle: "Write to us, the trail replies",
    form_fullname: "Full name",
    form_email: "Email",
    form_subject: "Subject",
    form_message: "Message",
    form_submit: "Send",
    form_submit_success: "Thank you, we will reply by email.",
  },
};

export const difficultyLabel = (d, lang) => ({
  it: { facile: "Facile", media: "Media", difficile: "Difficile" },
  en: { facile: "Easy", media: "Medium", difficile: "Hard" },
}[lang][d] || d);
